import _assetsAnimationLoading_orange_middleGif from "../../../assets/animation/loading_orange_middle.gif";
import _assetsAnimationLoading_orange_smallGif from "../../../assets/animation/loading_orange_small.gif";
import _assetsAnimationLoading_orangeGif from "../../../assets/animation/loading_orange.gif";
import _assetsAnimationLoading_grayGif from "../../../assets/animation/loading_gray.gif";
import _assetsAnimationLoading_gray_slowGif from "../../../assets/animation/loading_gray_slow.gif";

/* eslint-disable @typescript-eslint/no-var-requires */
import React, { useEffect, useRef } from 'react';
import { View, Animated, Easing, Image } from 'react-native';
import { CustomStyleSheet } from '../../../utils/rn/tools';
import LoadingCircle from '../../../assets/images/rn/LoadingCircle';
var module = {
  exports: {}
};
var exports = module.exports;
var GraySlowLoader = _assetsAnimationLoading_gray_slowGif;
var GrayLoader = _assetsAnimationLoading_grayGif;
var OrangeLoader = _assetsAnimationLoading_orangeGif;
var OrangeSmallLoader = _assetsAnimationLoading_orange_smallGif;
var OrangeMiddleLoader = _assetsAnimationLoading_orange_middleGif;
function Loader(styles) {
  var loaderData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : GrayLoader;
  var containerStyle = styles.containerStyle,
    imageStyle = styles.imageStyle;
  return /*#__PURE__*/React.createElement(View, {
    style: containerStyle
  }, /*#__PURE__*/React.createElement(Image, {
    style: imageStyle,
    source: loaderData
  }));
}
function ListLoader() {
  return Loader({
    containerStyle: styles['sp-list-loader'],
    imageStyle: styles['sp-list-loader-image']
  }, OrangeLoader);
}
function DescLoader() {
  return Loader({
    containerStyle: styles['sp-desc-loader'],
    imageStyle: styles['sp-desc-loader-image']
  });
}
function DialogueLoader() {
  return Loader({
    containerStyle: styles['sp-dialogue-loader'],
    imageStyle: styles['sp-dialogue-loader-image']
  }, GraySlowLoader);
}
function AgentLoadingLoader() {
  var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Loader(styles, OrangeSmallLoader);
}
function AgentDialogueLoader() {
  return Loader({
    containerStyle: styles['sp-agent-dialogue-loader'],
    imageStyle: styles['sp-agent-dialogue-loader-image']
  }, OrangeMiddleLoader);
}
function AgentUploadLoading() {
  var rotateAnimate = useRef(new Animated.Value(0)).current;
  var rotateInterpolation = rotateAnimate.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '360deg']
  });
  useEffect(function () {
    Animated.loop(Animated.timing(rotateAnimate, {
      toValue: 1,
      duration: 1000,
      easing: Easing.linear,
      useNativeDriver: true
    })).start();
  }, []);
  return /*#__PURE__*/React.createElement(Animated.View, {
    style: [styles['sp-agent-upload-loader'], {
      transform: [{
        rotate: rotateInterpolation
      }]
    }]
  }, /*#__PURE__*/React.createElement(LoadingCircle, {
    style: styles['sp-agent-upload-loader-image']
  }));
}
var commonLoaderImage = {
  width: '100%',
  height: '100%'
};
var styles = CustomStyleSheet({
  'sp-list-loader-image': commonLoaderImage,
  'sp-desc-loader-image': commonLoaderImage,
  'sp-dialogue-loader-image': commonLoaderImage,
  'sp-list-loader': {
    width: 42,
    height: 42
  },
  'sp-desc-loader': {
    width: 12,
    height: 12
  },
  'sp-dialogue-loader': {
    width: 24,
    height: 24,
    marginVertical: 4.8,
    marginHorizontal: 11.2
  },
  'sp-agent-dialogue-loader': {
    width: 24,
    height: 14.4,
    marginVertical: 9.6,
    marginHorizontal: 11.2
  },
  'sp-agent-dialogue-loader-image': {
    width: 24,
    height: 12.8
  },
  'sp-agent-upload-loader': {
    marginRight: 8,
    width: 16,
    height: 16
  },
  'sp-agent-upload-loader-image': {
    backgroundColor: 'transparent'
  }
});
export { Loader, ListLoader, DescLoader, DialogueLoader, AgentLoadingLoader, AgentDialogueLoader, AgentUploadLoading };
export default module.exports;